import { render, staticRenderFns } from "./PromotionsTable.vue?vue&type=template&id=171e3344&scoped=true&"
import script from "./PromotionsTable.vue?vue&type=script&lang=ts&"
export * from "./PromotionsTable.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsTable.vue?vue&type=style&index=0&id=171e3344&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171e3344",
  null
  
)

export default component.exports